import moment from "moment";
import type { Shipment } from "@api/graphql/generated/generated-types";
import { momentToTimePickerDate } from "@src/common/utils/timezoneConverters";
import { sortTasksBySequenceNumber } from "@src/shipments/utils/sortTasksBySequenceNumber";
import type { ManualArrivalFormData } from "../types";

export function buildManualArrivalFormDefaults(
  sortedStops: NonNullable<Shipment["stops"]>,
): ManualArrivalFormData {
  const defaults: ManualArrivalFormData = {};
  sortedStops.forEach((stop) => {
    sortTasksBySequenceNumber(stop.tasks).forEach((task) => {
      if (task.arrivedAt) {
        const d = momentToTimePickerDate(moment.unix(task.arrivedAt));
        defaults[task.id] = { date: d, time: d };
      } else {
        defaults[task.id] = { date: null, time: null };
      }
    });
  });
  return defaults;
}
